// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PanelLoader_Wrapper__cvIQ7","Loader":"PanelLoader_Loader__VmkbR"};